import "url:./Game/3d-object-files/**/*.glb";
import React, { FC } from "react";
// @ts-ignore
import LevelURL from "url:./Game/3d-object-files/Level1-1WITHPOND.glb";
import { createGlobalStyle } from "styled-components";
import { LevelController } from "./Engine/Commands/LevelController";
import { resolveLevelUrl } from "./Engine/Commands/LevelUtils";
import { Game } from "./Game/Game";

const BASE_FOLDER_URL = "./src/Game/3d-object-files";

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #react-root {
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
`;

export const App: FC = () => {
  const levelParameter = new URLSearchParams(window.location.search).get("level");
  const initialLevelUrl = levelParameter
    ? resolveLevelUrl(levelParameter, BASE_FOLDER_URL) || LevelURL
    : LevelURL;

  return (
    <>
      <GlobalStyle />
      <LevelController
        baseFolderUrl={BASE_FOLDER_URL}
        initialLevelUrl={initialLevelUrl}
      >
        <Game />
      </LevelController>
    </>
  );
};
